import actionTypes from '../actionTypes';

export function getDataRefreshTimestamp(data) {
	return {
		type: actionTypes.GET_DATA_REFRESH_TIMESTAMPS,
		payload: data,
	};
}

export function getDataRefreshTimestampSuccess(result) {
	return {
		type: actionTypes.GET_DATA_REFRESH_TIMESTAMPS_SUCCESS,
		payload: result,
	};
}

export function getDataRefreshTimestampFailure(error) {
	return {
		type: actionTypes.GET_DATA_REFRESH_TIMESTAMPS_FAILURE,
		payload: error,
	};
}

export function getNetSales(data) {
	return {
		type: actionTypes.GET_NET_SALES,
		payload: data,
	};
}
export function getNetSalesSuccess(result) {
	return {
		type: actionTypes.GET_NET_SALES_SUCCESS,
		payload: result,
	};
}
export function getNetSalesFailure(error) {
	return {
		type: actionTypes.GET_NET_SALES_FAILURE,
		payload: error,
	};
}
export function getUnit(data) {
	return {
		type: actionTypes.GET_UNIT,
		payload: data,
	};
}
export function getUnitSuccess(result) {
	return {
		type: actionTypes.GET_UNIT_SUCCESS,
		payload: result,
	};
}
export function getUnitFailure(error) {
	return {
		type: actionTypes.GET_UNIT_FAILURE,
		payload: error,
	};
}

export function getChannelBreakdownSales(data) {
	return {
		type: actionTypes.GET_CHANNEL_BREAKDOWN_SALES,
		payload: data,
	};
}
export function getChannelBreakdownSalesSuccess(result) {
	return {
		type: actionTypes.GET_CHANNEL_BREAKDOWN_SALES_SUCCESS,
		payload: result,
	};
}
export function getChannelBreakdownUnitsSuccess(result) {
	return {
		type: actionTypes.GET_CHANNEL_BREAKDOWN_UNITS_SUCCESS,
		payload: result,
	};
}
export function getChannelBreakdownGMVSuccess(result) {
	return {
		type: actionTypes.GET_CHANNEL_BREAKDOWN_GMV_SUCCESS,
		payload: result,
	};
}
export function getChannelBreakdownSalesFailure(error) {
	return {
		type: actionTypes.GET_CHANNEL_BREAKDOWN_SALES_FAILURE,
		payload: error,
	};
}

export function saveWeekFilter(data) {
	return {
		type: actionTypes.SAVE_WEEK_FILTER,
		payload: data,
	};
}
export function saveKpiName(data) {
	return {
		type: actionTypes.SAVE_KPI_NAME,
		payload: data,
	};
}

export function setTabValue(data) {
	return {
		type: actionTypes.SET_TAB_VALUE,
		payload: data,
	};
}

export function getUpcValidation(payload) {
	return {
		type: actionTypes.GET_UPC_VALIDATION,
		payload,
	};
}
export function getUpcValidationSuccess(payload) {
	return {
		type: actionTypes.GET_UPC_VALIDATION_SUCCESS,
		payload,
	};
}
export function getUpcValidationFailure(payload) {
	return {
		type: actionTypes.GET_UPC_VALIDATION_FAILURE,
		payload,
	};
}

export function setSelectedUPC(payload) {
	return {
		type: actionTypes.SELECTED_UPCS,
		payload,
	};
}

export function reloadShowHideCol(data) {
	return {
		type: actionTypes.RELOAD_SHOW_HIDE_COL,
		payload: data,
	};
}
